export const programsActionTypes = {
  PROGRAMS_REQUEST: "PROGRAMS_REQUEST",
  PROGRAMS_SUCCESS: "PROGRAMS_SUCCESS",
  PROGRAMS_FAIL: "PROGRAMS_FAIL",
};
